import { Avatar, Grid } from "@material-ui/core";
import React from "react";
import { Dock, User } from "lucide-react";

import "./index.css";
import { codeToParticipation } from "../../hooks/usePayment";
import { dateToServerString } from "../../commonUtils/date";

const VST = "1";

export default function CustomerDataModal(props) {
  const { state, isMain } = props;
  return (
    <div className="inner">
      <Grid container>
        <Grid item xs={12}>
          <div className="resume-title">
            <Avatar className="avatar">
              <User />
            </Avatar>
            <h4>Dati del genitore</h4>
          </div>
        </Grid>

        <Grid item xs={12} sm={6}>
          <p className="resume-label">Anagrafica</p>
          <ul className="resume-list">
            <li>
              Cognome: <b>{state.step1ParentSurname}</b>
            </li>
            <li>
              Nome: <b>{state.step1ParentName}</b>
            </li>
            <li>
              Genere: <b>{state.step1ParentGender}</b>
            </li>
            <li>
              Nazione di nascita:{" "}
              <b>
                {state.step1ParentNationality === "Italiana"
                  ? "ITALIA"
                  : state.step1ParentNationality}
              </b>
            </li>
            <li>
              Città di nascita:{" "}
              <b>
                {state.step1ParentNationality === "Italiana"
                  ? state.step1ParentBirthCity != null
                    ? state.step1ParentBirthCity.name
                    : null
                  : state.step1ParentForeignBirthCity}
              </b>
            </li>
            {state.step1ParentNationality === "Italiana" && (
              <li>
                Provincia di nascita: <b>{state.step1ParentBirthProv}</b>
              </li>
            )}
            <li>
              Data di nascita:{" "}
              <b>
                {dateToServerString(state.step1ParentBirthDate, "DD-MM-YYYY")}
              </b>
            </li>
            <li>
              Codice fiscale: <b>{state.step1ParentFiscalCode}</b>
            </li>
            <li>
              E-mail: <b>{state.step1ParentEmail}</b>
            </li>
            <li>
              Cellulare: <b>{state.step1ParentPhone}</b>
            </li>
          </ul>
        </Grid>

        <Grid item xs={12} sm={6}>
          <p className="resume-label">Residenza</p>
          <ul className="resume-list">
            <li>
              Via/Piazza: <b>{state.step1ParentStreetAddress}</b>
            </li>
            <li>
              Città: <b>{state.step1ParentResidenceCity}</b>
            </li>
            <li>
              CAP: <b>{state.step1ParentCAP}</b>
            </li>
            <li>
              Provincia: <b>{state.step1ParentProv}</b>
            </li>
          </ul>
          {isMain && (
            <>
              {state.step1ShippingAsResidence !== null && (
                <>
                  <p className="resume-label">
                    Indirizzo per la spedizione del kit
                  </p>
                  <ul className="resume-list">
                    <li>
                      Stessa della residenza del partecipante:{" "}
                      <b>{state.step1ShippingAsResidence ? "Sì" : "No"}</b>
                    </li>
                    {state.step1ShippingAsResidence === false && (
                      <>
                        {state.step1ShippingStreetAddress && (
                          <li>
                            Via/Piazza:{" "}
                            <b>{state.step1ShippingStreetAddress}</b>
                          </li>
                        )}
                        {state.step1ShippingCity && (
                          <li>
                            Città: <b>{state.step1ShippingCity}</b>
                          </li>
                        )}
                        {state.step1ShippingCAP && (
                          <li>
                            CAP: <b>{state.step1ShippingCAP}</b>
                          </li>
                        )}
                        {state.step1ShippingProv && (
                          <li>
                            Provincia: <b>{state.step1ShippingProv}</b>
                          </li>
                        )}
                        {state.step1ShippingRegion && (
                          <li>
                            Regione: <b>{state.step1ShippingRegion}</b>
                          </li>
                        )}
                        {state.step1ShippingNation && (
                          <li>
                            Nazione: <b>{state.step1ShippingNation}</b>
                          </li>
                        )}
                      </>
                    )}
                    {state.step1ShippingAdditionalInfo && (
                      <li>
                        Informazioni utili alla spedizione:{" "}
                        <b>{state.step1ShippingAdditionalInfo}</b>
                      </li>
                    )}
                  </ul>
                </>
              )}
            </>
          )}
        </Grid>

        <Grid item xs={12}>
          <div className="resume-title spacing">
            <Avatar className="avatar">
              <User />
            </Avatar>
            <h4>Dati del partecipante</h4>
          </div>
        </Grid>

        <Grid item xs={12} sm={6}>
          <p className="resume-label">Anagrafica</p>
          <ul className="resume-list">
            <li>
              Tipo di partecipazione:{" "}
              {isMain ? (
                <b>
                  {codeToParticipation(state.step2Participation)
                    .charAt(0)
                    .toUpperCase() +
                    codeToParticipation(state.step2Participation).slice(1)}
                </b>
              ) : (
                <b>{codeToParticipation(state.step2Participation)}</b>
              )}
            </li>
            <li>
              Cognome: <b>{state.step1ChildSurname}</b>
            </li>
            <li>
              Nome: <b>{state.step1ChildName}</b>
            </li>
            <li>
              Genere: <b>{state.step1ChildGender}</b>
            </li>
            <li>
              Nazione di nascita:{" "}
              <b>
                {state.step1ChildNationality === "Italiana"
                  ? "ITALIA"
                  : state.step1ChildBirthNation}
              </b>
            </li>
            <li>
              Città di nascita:{" "}
              <b>
                {state.step1ChildNationality === "Italiana"
                  ? state.step1ChildBirthCity != null
                    ? state.step1ChildBirthCity.name
                    : null
                  : state.step1ChildForeignBirthCity}
              </b>
            </li>
            {state.step1ChildNationality === "Italiana" && (
              <li>
                Provincia di nascita: <b>{state.step1ChildBirthProv}</b>
              </li>
            )}
            <li>
              Data di nascita:{" "}
              <b>
                {dateToServerString(state.step1ChildBirthDate, "DD-MM-YYYY")}
              </b>
            </li>
            <li>
              Codice fiscale: <b>{state.step1ChildFiscalCode}</b>
            </li>
            <li>
              E-mail: <b>{state.step1ChildEmail}</b>
            </li>
            <li>
              Cellulare: <b>{state.step1ChildPhone}</b>
            </li>
          </ul>
        </Grid>

        <Grid item xs={12} sm={6}>
          <p className="resume-label">Residenza</p>
          <ul className="resume-list">
            <li>
              Residente con il genitore:{" "}
              <b>{state.step1SameResidence ? "Sì" : "No"}</b>
            </li>
            <li>
              Via/Piazza: <b>{state.step1ChildStreetAddress}</b>
            </li>
            <li>
              Città: <b>{state.step1ChildResidenceCity}</b>
            </li>
            <li>
              CAP: <b>{state.step1ChildCAP}</b>
            </li>
            <li>
              Provincia: <b>{state.step1ChildProv}</b>
            </li>
          </ul>
        </Grid>

        {state.division === VST && state.flDocInserted !== "1" && (
          <Grid item xs={12}>
            <div className="resume-title spacing">
              <Avatar className="avatar">
                <Dock />
              </Avatar>
              <h4>Documento</h4>
            </div>

            <p className="resume-label">
              Vuoi fornirci sin da subito i dati del documento del Partecipante
              alla vacanza studio?
            </p>
            <ul className="resume-list">
              <li>
                <b>No, li comunicherò successivamente</b>
              </li>
            </ul>
          </Grid>
        )}

        {state.division === VST && state.flDocInserted === "1" && (
          <Grid item xs={12}>
            <div className="resume-title spacing">
              <Avatar className="avatar">
                <Dock />
              </Avatar>
              <h4>Documento</h4>
            </div>

            <ul className="resume-list">
              <li>
                Tipo documento:{" "}
                <b>
                  {state.step1ChildDocType
                    ? state.step1ChildDocType === "idCard"
                      ? "Carta d'identità"
                      : "Passaporto"
                    : ""}
                </b>
              </li>
              <li>
                Numero documento: <b>{state.step1ChildDocNumber}</b>
              </li>
              <li>
                Nazionalità riportata sul documento:{" "}
                <b>{state.step1ChildDocCountry}</b>
              </li>
              <li>
                Data emissione:{" "}
                <b>
                  {dateToServerString(
                    state.step1ChildDocEmission,
                    "DD-MM-YYYY"
                  )}
                </b>
              </li>
              <li>
                Data scadenza:{" "}
                <b>
                  {dateToServerString(
                    state.step1ChildDocExpiration,
                    "DD-MM-YYYY"
                  )}
                </b>
              </li>
            </ul>
          </Grid>
        )}
      </Grid>
    </div>
  );
}
